import { Sidebar } from "primereact/sidebar";

// Wrapper fino sobre o Sidebar do PrimeReact, com a mesma convenção de header/footer do Modal
// (componentes/modal/modal.jsx) — usado para os painéis que abrem pela direita no módulo de
// Solicitações (hoje só o de Encaminhamento, mas reutilizável para outros no futuro).
export default function DrawerLateral({ isOpen, onClose, title, subtitle, children, footer, className }) {
    return (
        <Sidebar
            visible={isOpen}
            onHide={onClose}
            position="right"
            blockScroll
            className={`w-[95%] sm:w-[420px] ${className || ""}`}
        >
            {title && (
                <h3 className="font-display text-lg leading-6 font-semibold text-foreground">{title}</h3>
            )}
            {subtitle && (
                <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>
            )}

            <div className="mt-4 flex flex-col gap-4">
                {children}
            </div>

            {footer && (
                <div className="mt-6 pt-4 border-t border-border">
                    {footer}
                </div>
            )}
        </Sidebar>
    );
}
